// extracted by mini-css-extract-plugin
export default {"divider":"SLMe1VjAX3a_gDFOxkLc","termBox":"VjgI_wWP8YdtUm6SSseO","submitBox":"msOG_AhnIYIRe8m8WOz1"};